<template>
  <div class="visit">
    <header class="search">
      <a-select class="search-select" v-model:value="queryParam.planType" @change="selChange">
        <a-select-option v-for="option in visitType" :value="option.value" :key="option.value">
          {{ option.label }}
        </a-select-option>
      </a-select>
      <a-select class="search-select" v-model:value="queryParam.planStatus">
        <a-select-option
          v-for="option in visitType[queryParam.planType].condition"
          :value="option.value"
          :key="option.value"
        >
          {{ option.label }}
        </a-select-option>
      </a-select>
      <a-button @click="onPageOrSize" class="search-button" type="primary">搜索</a-button>
    </header>
    <!-- 随访表单 -->
    <a-table
      class="table"
      :loading="visits.loading"
      :pagination="visits.pagination"
      :rowKey="(record, index) => index"
      :columns="columns"
      :data-source="visits.data"
      @showSizeChange="onPageOrSize"
      @change="onPageOrSize"
      show-quick-jumper
      :scroll="{ y: 'calc(100vh - 400px)', x: '100%' }"
      :transformCellText="({ text }) => text ?? '--'"
    >
      <template #planName="{ record, text }">
        <span>
          {{ record.medicationScheduleId ? '随访计划' : text || '--' }}
        </span>
      </template>
      <!-- 临观标识 和 关联处方 -->
      <template #relevancyPrescriptions="{ record, text }">
        <auth-img
          v-if="record.activityFlag"
          class="lin-guan-tag"
          src="@/assets/img/work-place/lin-guan.png"
          alt="lin-guan"
        />
        <template v-if="text && text.length">
          <span
            class="table-link"
            v-for="(item, index) in text"
            :key="item"
            @click="onOperation(subStringToType(item), void 0, item)"
          >
            {{ item }}
            <i v-if="record.relevancyPrescriptions.length !== index + 1">,</i>
          </span>
        </template>
        <template v-else>--</template>
      </template>
      <!-- 查看详情 -->
      <template #handle="data">
        <a-button class="button-link" type="link" @click="toDetail(data.record)">查看详情</a-button>
      </template>
    </a-table>
    <the-detail
      v-model:visible="visits.detail.show"
      :id="visits.detail.id"
      :mode="mode"
      :recordType="visits.detail.recordType"
      :serialNumber="visits.detail.serialNumber"
      :planType="queryParam.planType"
      :visitPageType="visits.visitPageType"
    />
  </div>
</template>
<script setup>
import { subStringToType } from '@/utils/index'
import TheDetail from '@/components/TheDetail/index.vue'
import { columns, condition, visitType } from './hooks/config'
import useVisits from './hooks/useVisits'
import { defineProps } from 'vue'
import { isPlanOrVisitMethods } from '@/hooks/globalApi'
const props = defineProps({
  ucUserId: {
    type: Number,
    default: null
  },
  mode: {
    type: String,
    default: ''
  }
})
const { onPageOrSize, queryParam, visits, onOperation } = useVisits(props)

const toDetail = record => {
  isPlanOrVisitMethods({ id: record?.medicationScheduleId || record?.followupPlanId }, res => {
    const id = res.dateFlg
      ? res.id
        ? res.id
        : record?.medicationScheduleId || record?.followupPlanId
      : record.followupPlanId
    onOperation('visit', id)
  })
}
const selChange = value => {
  // 如果是平台就默认选中第一个
  if (value === visitType[0].value) {
    queryParam.planStatus = 1
  } else {
    queryParam.planStatus = null
  }
}
</script>
<style lang="scss" scoped>
.search {
  text-align: right;
  margin: 10px 20px 0;

  &-select {
    margin-right: 12px;
    width: 112px;
    text-align: left;
  }
}

.table {
  margin: 10px 20px 0;

  .lin-guan-tag {
    vertical-align: text-top;
  }

  .table-link {
    color: #1890ff;
    cursor: pointer;
    margin-left: 5px;
    vertical-align: text-bottom;
    word-break: break-all;
  }
  .button-link {
    padding: 0;
  }
}
</style>
